import axios from 'axios';


let base = sessionStorage.getItem("base_url") || window.location.host;
const api_mapping = {
    'production': `https://${base}`,
    'staging': `http://${base}`
}


const ws_mapping = {
    'production': `wss://${base}`,
    'staging': `ws://${base}`
}

const chatBaseURL = ['production', 'staging'].includes(process.env.REACT_APP_ENV) ? `${api_mapping[process.env.REACT_APP_ENV]}/chat`: process.env.REACT_APP_CHAT_BASE_URL;
const websocketBaseURL = ['production', 'staging'].includes(process.env.REACT_APP_ENV) ? `${ws_mapping[process.env.REACT_APP_ENV]}/chat`:process.env.REACT_APP_CHAT_BASE_URL;
console.log("chatBaseURL==============", chatBaseURL)
const api = axios.create({
    baseURL: ['production', 'staging'].includes(process.env.REACT_APP_ENV) ? `${api_mapping[process.env.REACT_APP_ENV]}/api` :  process.env.REACT_APP_API_BASE_URL,
    withCredentials: true
});

// Add a request interceptor to attach token
api.interceptors.request.use(
    (config) => {
        const token = sessionStorage.getItem("token");
        if (token) {
            config.headers["Authorization"] = token;
        }
        config.headers['X-Forwarded-Host'] = window.location.host;
        return config;
    },
    (error) => Promise.reject(error)
);

api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response && (error.response.status === 401)) {
            sessionStorage.removeItem("token"); // Clear token
        }
        if (error.response && (error.response.status === 403)) {
            window.location.replace('http://solio.reyzap.com');
        }
        return Promise.reject(error);
    }
);
export default api;
export { chatBaseURL, websocketBaseURL };